export var classListSupport = 'classList' in document.createElement('_');



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/lib/helpers/classListSupport.js